import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AccordionArticleCategoryPanelComponent,
  AccordionArticleFilterComponent,
  AccordionArticleSubcategoryPanelComponent,
} from '@domgen/dgx-fe-components/accordion';
import { SectionLoadingDirective } from '@domgen/dgx-fe-components/loading';
import { ArticleFilterComponentService } from '../../services/article-filter-component/article-filter-component.service';
import { SmartFixHubAnalyticsService } from 'libs/self-fix/data-access/src/lib/services/sf-hub-analytics/sf-hub-analytics-service';

@Component({
  selector: 'dg-article-filter',
  standalone: true,
  imports: [
    AccordionArticleCategoryPanelComponent,
    AccordionArticleFilterComponent,
    AccordionArticleSubcategoryPanelComponent,
    AsyncPipe,
    NgIf,
    SectionLoadingDirective,
  ],
  providers: [ArticleFilterComponentService],
  templateUrl: './article-filter.component.html',
  styleUrls: ['./article-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleFilterComponent {
  @Input() sharedSectionLoading: boolean = false;
  constructor(
    readonly cs: ArticleFilterComponentService,
    readonly smartFixAnalytics: SmartFixHubAnalyticsService
  ) {}

  ngOnInit(): void {
    this.smartFixAnalytics.trackEvent({
      pagename: 'claims-sf-hub-search-results',
      event: 'spa-pageview',
    });
  }
}
